module.exports = __webpack_public_path__ + "img/easyShyftDark.7ea2b6be.png";